import Vue from 'vue';
import App from './App.vue';
import ElementUI, { Loading } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/ja';

import store from '@/store'

Vue.config.productionTip = false;
Vue.use(ElementUI, {locale}, Loading)

new Vue({
  loading: Loading,
  store,
  render: h => h(App)
}).$mount('#app');